import React from 'react';
import IntroSection from '../components/IntroSection';
import UXOverview from '../components/UXOverview';
import BlueSectionDivider from '../components/BlueSectionDivider';
import UXProcess from '../components/UXProcess';
import UXProjects from '../components/UXProjects';
import TeamSection from '../components/TeamSection';
import WhyUsSection from '../components/WhyUsSection';
import WorkingModelSection from '../components/WorkingModelSection';
import TechStackSection from '../components/TechStackSection';
import UXFaq from '../components/UXFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
const UxAudit =()=>{
    return(
        <div>
            <IntroSection title ="UX AUDIT" paragraph="Get actionable insights for more conversions and a better user experience." backgroundImage="/images/ux-bg.webp"/>
            <UXOverview/>
            <BlueSectionDivider/>
            <UXProcess/>
            <UXProjects/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <UXFaq/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default UxAudit;